// components/parcours-client/RecapInfoBox.js
import React from "react";
import { Paper, Typography, Box, Divider, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const InfoRow = ({ label, value }) => (
  <Box sx={{ mb: 1 }}>
    <Typography sx={{ fontWeight: 600 }}>{label}</Typography>
    <Typography sx={{ fontSize: "0.9rem", color: "#333" }}>
      {value ?? "-"}
    </Typography>
  </Box>
);

const RecapInfoBox = ({ formData, onEdit }) => {
  const { t } = useTranslation("parcours-client/RecapInfoBox");

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: "#f4f4f4",
        borderRadius: "16px",
        p: 3,
        width: "100%",
        maxWidth: 320,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Typography fontWeight={700} fontSize="1.1rem" mb={1}>
          {t("sections.myInfo")}
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <InfoRow
          label={t("fields.name")}
          value={`${formData.nom || ""} ${formData.prenom || ""}`.trim()}
        />
        <InfoRow label={t("fields.phone")} value={formData.telephone} />
        <InfoRow label={t("fields.email")} value={formData.email} />

        <Typography fontWeight={700} fontSize="1.1rem" mt={3} mb={1}>
          {t("sections.myBike")}
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <InfoRow
          label={t("fields.model")}
          value={`${formData.marque || ""} ${formData.modele || ""}`.trim()}
        />
        <InfoRow label={t("fields.type")} value={formData.bikeType} />
        <InfoRow
          label={t("fields.price")}
          value={
            formData.prix !== undefined && formData.prix !== null
              ? `${formData.prix} €`
              : "-"
          }
        />
        <InfoRow
          label={t("fields.purchaseDate")}
          value={formData.dateAchat}
        />
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
        <Button
          variant="outlined"
          onClick={onEdit}
          sx={{
            textTransform: "none",
            borderRadius: "12px",
            fontWeight: 600,
            color: "#4d4d4d",
            borderColor: "#4d4d4d",
            "&:hover": {
              backgroundColor: "#d4d4d4ff",
              borderColor: "#4d4d4d",
              color: "#4d4d4d",
            },
          }}
        >
          {t("actions.edit")}
        </Button>
      </Box>
    </Paper>
  );
};

export default RecapInfoBox;